import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { getQueryString } from '../../utils/filters-util';
import { fetchTrackingListApi } from '../../api/trackings-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  trackings: [],
  caseTypes: [],
  pharmacies: [],
  statuses: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchTrackingsListing = createAsyncThunk(
  'trackings/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      sort: 'created_at desc',
      ...updatedParamsObject,
    };
    const res = await fetchTrackingListApi(paramsObj, '');
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
  },
);

const TrackingsSlice = createSlice({
  name: 'trackings',
  initialState,
  reducers: {
    setTrackingsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setTrackingsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTrackingsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchTrackingsListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.caseTypes = action?.payload?.case_communication_types || [];
        state.pharmacies = action?.payload?.pharmacy_list || [];
        state.statuses = action?.payload?.pharmacy_trackings_statuses || [];
        state.trackings = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchTrackingsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setTrackingsActiveColumn, setTrackingsLoading } = TrackingsSlice.actions;
export default TrackingsSlice.reducer;
